import Fab from '@mui/material/Fab';
import PublishIcon from '@mui/icons-material/Publish';

export default function FloatingActionButtonTop() {
  return (
        <Fab size="small" color="primary" aria-label="add"
            sx={{
                position: "fixed",
                bottom: 78,
                right: 24,
                zIndex: 1000,
                backgroundColor: "rgba(0, 150, 136, 0.5)" // teal with 0.5 opacity
            }}
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        >
             <PublishIcon />
        </Fab>
    )
}
